import React from "react";
import './CustomNode.css';

const getPlaceholderText = (tag) => {
  const placeholders = {
    "主張": "主張を入力してください...",
    "根拠": "根拠を入力してください...",
    "具体例": "具体例を入力してください...",
    "結論": "結論を入力してください...",
  };
  return placeholders[tag] || "内容を入力してください...";
};

const ClonedNode = ({ data }) => {
  const { label, tag, isIsolated, isCycled, isShadowHidden, selected } = data;

  const getTagColor = (tag) => {
    const colors = {
      "主張": "#f28482",
      "根拠": "#84a9f4",
      "具体例": "#f6bd60",
      "結論": "#90be6d"
    };
    return colors[tag] || "#333";
  };

  const getBorderColor = () => {
    if (isIsolated) return '#ffa500';
    if (isCycled) return '#ff0072';
    if (selected) return '#007bff';
    return '#007bff';
  };

  const nodeStyle = {
    position: "relative",
    padding: "28px 14px 14px",
    border: `2px solid ${getBorderColor()}`,
    borderRadius: "6px",
    backgroundColor: "#fff",
    width: "260px",
    wordWrap: "break-word",
    lineHeight: "1.6",
    boxShadow: isShadowHidden ? 'none' 
    : (
      isIsolated || isCycled
        ? `0 0 12px ${getBorderColor()}`
        : "3px 3px 12px rgba(0,123,255,0.3)"
    ),
    transition: "all 0.2s ease",
  };

  const textareaStyle = {
    minHeight: '80px',
    boxSizing: "border-box",
    width: "100%",
    padding: "2px",
    fontSize: "14px",
    fontFamily: "inherit",
    lineHeight: "1.6",
    resize: "none",
    outline: "none",
    border: "1px solid transparent",
    backgroundColor: "transparent",
    cursor: "text",
    overflow: "hidden",
  };

  return (
    <div style={nodeStyle} className={(isCycled) ? 'node-pulse' : ''}>
      <div
        style={{
          position: "absolute",
          top: "-16px",
          left: "12px",
          background: "#fff",
          border: `2px solid ${getBorderColor()}`,
          borderRadius: "4px",
          padding: "3px 8px",
          fontSize: "12px",
          fontWeight: "bold",
          boxShadow: "2px 2px 4px rgba(0,0,0,0.1)",
          transition: "border-color 0.2s ease",
        }}
        className="nodrag"
      >
        <select
          value={tag}
          readOnly
          style={{
            border: "none",
            background: "transparent",
            fontSize: "12px",
            fontWeight: "bold",
            color: getTagColor(tag),
            cursor: "pointer",
            outline: "none",
            pointerEvents: "none",
          }}
        >
          <option value="主張">主張</option>
          <option value="根拠">根拠</option>
          <option value="具体例">具体例</option>
          <option value="結論">結論</option>
        </select>
      </div>

      <div style={{ fontSize: "14px", minHeight: "20px", marginTop: '-8px' }}>
        <textarea
          value={label || ""}
          readOnly={true}
          style={textareaStyle}
          placeholder={getPlaceholderText(tag)}
        />
      </div>

      <div style={{
        position: 'absolute',
        top: '50%',
        left: -10,
        width: 14,
        height: 14,
        background: '#007bff',
        border: '1px solid white',
        borderRadius: '50%',
        transform: 'translateY(-50%)',
        boxSizing: 'border-box',
      }} />

      <div style={{
        position: 'absolute',
        top: '50%',
        right: -10,
        width: 14,
        height: 14,
        background: '#007bff',
        border: '1px solid white',
        borderRadius: '50%',
        transform: 'translateY(-50%)',
        boxSizing: 'border-box',
      }} />
    </div>
  );
};

export default ClonedNode;
